<div [style.background-color]="backgroundColor" class="idp-offer-action-banner">
  <div
    class="idp-offer-action-container"
    [ngClass]="orientation === 'vertical' ? '--vertical' : '--horizontal'"
  >
    <ng-container *ngIf="inputType === 'button'">
      <div
        [innerHTML]="message"
        [style.color]="messageStyles?.fontColor"
        [style.font-family]="messageStyles?.fontType"
        [style.font-size]="messageStyles?.fontSize"
        class="idp-offer-action__text"
        data-cy="idp-offer-action-banner-description"
      ></div>
      <div
        [style.color]="buttonLabelStyles?.fontColor"
        [style.font-family]="buttonLabelStyles?.fontType"
        [style.font-size]="buttonLabelStyles?.fontSize"
        class="idp-offer-action__btn"
      >
        <idp-button
          (notify)="offerActionFromButton($event)"
          [id]="buttonId || '#'"
          [label]="buttonLabel ?? ''"
          [ariaLabel]="axTitle + buttonLabel + 'opens in a new tab'"
          [size]="actionSize ?? 'full-width'"
          [type]="actionType ?? 'secondary'"
          data-cy="idp-offer-action-banner-action-button"
        ></idp-button>
      </div>
      <idp-link
        *ngIf="secondaryLink && secondaryLink.url"
        [id]="secondaryLinkId || '#'"
        class="idp-offer-action-container--content-description-link"
        [label]="secondaryLink.label"
        [axLabel]="axTitle + secondaryLink.label"
        [actionUrl]="secondaryLink.url"
        [labelSize]="'large'"
      ></idp-link>
    </ng-container>
    <ng-container *ngIf="inputType === 'checkbox'">
      <div
        [style.color]="messageStyles?.fontColor"
        [style.font-family]="messageStyles?.fontType"
        [style.font-size]="messageStyles?.fontSize"
        class="idp-offer-action__checkbox"
      >
        <idp-checkbox-standard
          (clicked)="offerActionFromCheckbox($event)"
          [labelTitle]="message"
          [uncheckedBackground]="'white'"
        ></idp-checkbox-standard>
      </div>
    </ng-container>
  </div>
</div>
